module.exports = ":host .u-radio {\n  min-width: 220px; }\n"